import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Spin, Select, DatePicker, Input, Button, Row, Col, message } from 'antd';
import InfiniteScroll from 'react-awesome-infinite-scroll';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import api from '@api/api';
import GoBack from "@view/compoents/goBack/goBack";
import SkuItem from '../components/skuItem'
import PSAIModal from '@PSAIComponents/PSAIModal';
import utils from '@utils/utils.js'
import eventBus from '@utils/eventBus';
import PreviewImage from '../components/previewImage';


const SkuList = () => {

    const location = useLocation();
    const { title, id } = location.state;
    const [skuListData, setskuListData] = useState([])
    const [showStatus, setshowStatus] = useState(1)
    const [selectIDs, setSelectIDs] = useState([])
    const [isSelected, setIsSelected] = useState(false)
    const [isSelectedAll, setIsSelectedAll] = useState(false)
    const [downLoading, setdownLoading] = useState(false)
    const [open, setopen] = useState(false)
    const [open2, setopen2] = useState(false)
    const [alldata, setalldata] = useState({})
    const [dowmloadCount, setdowmloadCount] = useState(-1) //有效下载

    const [previewVisible, setPreviewVisible] = useState(false) // 预览图片\相册
    const [previewCurrent, setPreviewCurrent] = useState()
    const [previewItems, setpreviewItems] = useState([])
    const [isSpinning, setisSpinning] = useState(false)

    useEffect(() => {
        if (!id) return
        listArtifactsBySku()
    }, [id])
    const getSelectids = (id) => {
        setIsSelectedAll(false)
        if (selectIDs.includes(id)) {
            setSelectIDs(selectIDs.filter((item) => item !== id));
        } else {
            setSelectIDs([...selectIDs, id]);
        }
    };


    const listArtifactsBySku = () => {
        setisSpinning(true)
        api.listArtifactsBySku({
            detailId: id
        }).then((res) => {
            if (res.code == 0) {
                let data = res.data?.artifacts || [];
                const { priorityItems, otherItems } = data.reduce((acc, item) => {
                    if (item.status === 2 || item.status === 3) {
                        acc.priorityItems.push(item);
                    } else {
                        acc.otherItems.push(item);
                    }
                    return acc;
                }, { priorityItems: [], otherItems: [] });

                setskuListData([...priorityItems, ...otherItems]);
                setshowStatus(res.data?.status)
                setalldata(res.data)
                setisSpinning(false)
            } else {
                message.warning(res.message)
            }
        })
    }

    function checkvaildDownload() {
        // 计算已下载过的成片张数
        let count = 0;
        for (const id of selectIDs) {
            const matchingItems = skuListData.filter(item => item.id === id && item.deliverStatus === 1);
            count += matchingItems.length;
        }

        return count;
    }

    const downloadClick = () => {
        console.log('已下载', checkvaildDownload())
        console.log('有效下载', selectIDs.length - checkvaildDownload())
        setdowmloadCount(selectIDs.length - checkvaildDownload())
    }

    useEffect(() => {
        if (!isSelected || dowmloadCount == -1) return
        if (remainCount >= (selectIDs.length - checkvaildDownload())) {
            confirmDown()
        } else {
            setopen(true)
        }
    }, [dowmloadCount])

    const confirmDown = () => {
        setdownLoading(true)
        if (selectIDs.length == 1) {
            api.merchantdownload({
                artifactId: selectIDs[0]
            }).then((res) => {
                
                if (res.code == 0) {
                    return utils.downloadFileWithToken(res?.data).then(() => {
                        eventBus.emit('updatePower')
                        message.success('下载成功');
                        setSelectIDs([])
                        setIsSelectedAll(false)
                        setIsSelected(false)
                        listArtifactsBySku()
                        setdowmloadCount(-1)
                        setdownLoading(false)
                        setopen(false)
                    }).catch(() => {
                        setdowmloadCount(-1)
                        setdownLoading(false)
                        message.warning('下载失败，请稍后重试');
                    })
                } else {
                    message.warning(res.message)
                }
            })
        } else {
            api.merchantdownloadBatch({
                artifactIds: selectIDs
            }).then((res) => {
                if (res.code == 0) {
                    return utils.downloadFileWithToken(res?.data).then(() => {
                        setopen(false)
                        setSelectIDs([])
                        setIsSelectedAll(false)
                        setIsSelected(false)
                        listArtifactsBySku()
                        setdowmloadCount(-1)
                        setdownLoading(false)
                        eventBus.emit('updatePower')
                        message.success('下载成功');
                    }).catch(() => {
                        setdowmloadCount(-1)
                        setdownLoading(false)
                        message.warning('下载失败，请稍后重试');
                    })
                } else {
                    message.warning(res.message)
                }
            })
        }
    }

    const selectAll = () => {
        setIsSelectedAll(!isSelectedAll)
        if (isSelectedAll) {
            setSelectIDs([])
        } else {
            setSelectIDs([])
            let allArr = skuListData.map(obj => obj.id)
            setSelectIDs([...allArr])
        }
    }

    const modalConfirm = () => {
        confirmDown()
    }

    function checkvaildEdit() {
        // 计算已经选项中有多少交付过图，禁止精修
        let count = 0;
        for (const id of selectIDs) {
            const matchingItems = skuListData.filter(item => item.id === id && item.deliverStatus === 1);
            count += matchingItems.length;
        }

        return count;
    }

    const checkdownCount = useMemo(() => { // 计算选项中已交付的数量
        return checkvaildEdit()
    }, [selectIDs])



    const merchantrefine = () => {
        setdownLoading(true)
        api.merchantrefine({
            artifactIds: selectIDs
        }).then((res) => {
            setdownLoading(false)
            if (res.code == 0) {
                setSelectIDs([])
                setIsSelectedAll(false)
                setIsSelected(false)
                message.success('已发起精修！')
                setopen2(false)
                listArtifactsBySku()
            } else {
                message.warning(res.message)
            }
        })
    }

    const remainCount = useMemo(() => {
        return (alldata.finishCount - alldata.deliveryFinishCount) > 0 ? (alldata.finishCount - alldata.deliveryFinishCount) : 0 // 剩余可用张数
    }, [dowmloadCount])

    const overCount = useMemo(() => { // 超出的张数
        let remainCounts = (alldata.finishCount - alldata.deliveryFinishCount) > 0 ? (alldata.finishCount - alldata.deliveryFinishCount) : 0
        return remainCounts - dowmloadCount
    }, [dowmloadCount])

    const editCount = useMemo(() => { // 剩余精修次数
        return alldata.refineTimes - alldata.refineTimesUsed
    }, [alldata.refineTimesUsed])

    const deliveryAll = useMemo(() => { // 订单已完成

        if (alldata.status === 3) {
            return true
        } else {
            return false
        }
    }, [alldata.status])

    const preViewClick = (index) => {
        setpreviewItems([...skuListData])
        setPreviewCurrent(index)
        setPreviewVisible(true)
    }

    const downoncePic = (e, id, deliverStatus) => {
        e.stopPropagation()
        if (alldata.status === 3 && deliverStatus != 1) {
            setdowmloadCount(1)
            setopen(true)
            setSelectIDs([id])
        } else {
            api.merchantdownload({
                artifactId: id
            }).then((res) => {
                if (res.code == 0) {
                    return utils.downloadFileWithToken(res?.data).then(() => {
                        listArtifactsBySku()
                        eventBus.emit('updatePower')
                        message.success('下载成功');
                    }).catch(() => {
                        message.warning('下载失败，请稍后重试');
                    })
                } else {
                    message.warning(res.message)
                }
            })
        }

    }

    return (
        <>
            <div className={styles.SkuList}>
                <Spin spinning={isSpinning}>
                    <div className={styles.top}>
                        <GoBack /> 
                        {/* <span>需求编号：{title}</span> */}
                    </div>
                    {
                        showStatus === 0 ? <div className={styles.nullPage}>
                            <img src={require('@assets/images/nullpage.png')} />
                            <p>您的订单正在火速处理中~</p>
                        </div> : <>
                            {/* <div className={styles.head_info}>
                                <span>需求编号：{title}</span>
                                <div className={styles.info_item}>
                                    <ul>
                                        <li>{alldata.deliveryFinishCount}/{alldata.finishCount} 张</li>
                                        <li>已下载成片</li>
                                    </ul>
                                </div>
                                <div className={styles.info_item}>
                                    <ul>
                                        <li> {alldata.refineTimesUsed}/{alldata.refineTimes} 次</li>
                                        <li>已使用精修次数</li>
                                    </ul>
                                </div>
                            </div> */}
                            <div className={styles.head_info}>
                                <span className={styles.title}>需求编号：{title}</span>
                                <div className={styles.info_container}>
                                    <div className={styles.info_item}>
                                        <ul>
                                            <li>已下载成片:<span style={{fontSize:".24rem", paddingRight:".03rem", fontWeight:'500'}}>{alldata.deliveryFinishCount}</span>/<span>{alldata.finishCount} 张</span></li>
                                            {/* <li>已下载成片</li> */}
                                        </ul>
                                    </div>
                                    <div className={styles.info_item}>
                                        <ul>
                                            <li>已使用精修次数:<span style={{fontSize:".24rem", paddingRight:'.03rem'}}>{alldata.refineTimesUsed}</span>/{alldata.refineTimes} 次</li>
                                            {/* <li>已使用精修次数</li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.selectBox}>
                                <p>
                                    <span className={styles.span_1}>已交付图片</span>
                                    <span>共 {skuListData.length} 张</span>
                                </p>
                                <div className={styles.options_opts}>
                                    {!isSelected && <Button className={styles.options_select} onClick={() => setIsSelected(true)}>选择</Button>}
                                    {isSelected &&
                                        <>
                                            <Button onClick={() => selectAll()}>{isSelectedAll ? '取消全选' : '全选'}</Button>
                                            <Button disabled={selectIDs.length == 0} loading={downLoading} onClick={() => selectIDs.length > 0 ? downloadClick() : message.warning('请选择一条sku')}>下载</Button>
                                            <Button disabled={selectIDs.length == 0 || editCount <= 0 || deliveryAll || checkdownCount == selectIDs.length} onClick={selectIDs.length > 0 ? () => setopen2(true) : () => message.warning('请选择一张成片！')}>发起精修</Button>
                                            <Button
                                                style={{ background: '#edf0ff' }}
                                                onClick={() => {
                                                    setIsSelected(false);
                                                    setSelectIDs([]);
                                                    setdowmloadCount(-1);
                                                    setIsSelectedAll(false)
                                                }}
                                            >取消</Button>
                                        </>
                                    }
                                </div>
                            </div>
                            <div className={styles.picBox}>
                                {
                                    skuListData && skuListData.map((item, index) => {
                                        return <SkuItem onClick={isSelected ? null : () => preViewClick(index)} downoncePic={downoncePic} isSelected={isSelected} selectIDs={selectIDs} item={item} getSelectids={getSelectids} />
                                    })
                                }
                            </div>
                        </>
                    }
                </Spin>
            </div>
            <PSAIModal
                title={'是否继续下载'}
                closeIcon={null}
                open={open}
                maxWidth={500}
                cancelText="重新选择 "
                onCancel={() => {
                    setopen(false)
                    setdowmloadCount(-1)
                }}
                okText="继续下载"
                confirmLoading={downLoading}
                onOk={() => modalConfirm()}
            >
                <p style={{ marginBottom: '20px', marginTop: '20px' }} className={styles.ps_download}>您已超出此订单下载上限,继续下载将扣除<span>{overCount >= 0 ? 0 : (Math.abs(overCount) * alldata.eachAmount)}</span>虹豆</p>
            </PSAIModal>
            <PSAIModal
                title={'是否使用精修权益'}
                closeIcon={null}
                open={open2}
                maxWidth={500}
                cancelText="取消 "
                onCancel={() => setopen2(false)}
                okText="确认"
                confirmLoading={downLoading}
                onOk={() => merchantrefine()}
            >
                {
                    checkdownCount > 0 ? <p style={{ marginTop: '20px', paddingLeft: '25px' }} className={styles.ps_download}>您选择的图中包含已下载的图，本次精修仅对未下载的图发起精修</p> :
                        <p style={{ marginTop: '20px', paddingLeft: '25px' }} className={styles.ps_download}>您已选择{selectIDs.length}张图片进行精修，点击确认后将扣除一次精修次数</p>
                }
            </PSAIModal>
            <PreviewImage
                open={previewVisible}
                closeFunc={() => setPreviewVisible(false)}
                items={previewItems}
                current={previewCurrent}
                showBookmark={false}
                imageType={'model'}
                projectName={'projectName'}
            />
        </>

    );
}

export default SkuList